import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {wrapActionCreator} from '../../../../helpers/reduxHelpers';
import {Dispatch} from '../../../../store/appStore';
import {toggleLastRuleCreatedAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getLastRuleCreated} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {getUser} from '../../../../store/data/teammates/teammatesSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {RuleCreatedBanner} from './ruleCreatedBanner';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  rule: getLastRuleCreated,
  user: getUser,
}));

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    navigateToLinkAction: wrapActionCreator(dispatch, navigateToLinkAction),
    toggleLastRuleCreatedAction: wrapActionCreator(dispatch, toggleLastRuleCreatedAction),
  };
}

export const RuleCreatedBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, _ownProps) => ({
    ...stateProps,
    onViewRule: () => {
      if (!stateProps.rule) {
        return;
      }

      const rulePath = `/settings/${stateProps.user.namespace}/rules/edit/${stateProps.rule.id}`;
      dispatchProps.navigateToLinkAction(rulePath);
      dispatchProps.toggleLastRuleCreatedAction(stateProps.rule, true);
    },
  }),
)(RuleCreatedBanner);
